
import { mapState, mapGetters } from 'vuex'
import baseLogic from '~/mixins/base-logic'
import cms from '~/mixins/common/cms'
import Meta from '~/mixins/meta'
import ServerSide from '~/mixins/serverSide'
import { globalVar } from '~/utils/globalVar'

export default {
    name: 'Theme4',
    mixins: [baseLogic, cms, Meta, ServerSide],
    data() {
        return {
            isMobileScreen: false,
            globalVar,
            country_code: 'LA',
        }
    },
    computed: {
        ...mapGetters({
            faviconIcon: 'cms/faviconIcon',
            supportCountries: 'themes/settings/supportCountry',
            languages: 'themes/settings/language',
        }),
        ...mapState({
            menubars: (state) => state.cms.menus.menus,
            isLogin: (state) => state.settings.isLogin,
            displayRegisterModal: (state) =>
                state.themes.settings.displayRegisterModal,
            showHoldBalance: (state) => state.sockets.showHoldBalance,
            displayGetBonusDetail: (state) =>
                state.sockets.displayGetBonusDetail,
            displayGetBonusModalState: (state) =>
                state.sockets.displayGetBonusModal,
            withdrawalStatus: (state) => state.sockets.withdrawalStatus,
            displayWithdrawalSocketState: (state) =>
                state.sockets.displayWithdrawalSocket,
            floatingIcons: (state) => state.cms.floatingIcons,
            hiddenOverflowLanguageChange: (state) =>
                state.settings.hiddenOverflowLanguageChange,
        }),
        navbarName() {
            if (this.isMobileOnly()) {
                return 'Theme4MobileNavBar'
            }
            return 'Theme4DesktopNavBar'
        },
        displayGetBonusModal: {
            get() {
                return this.displayGetBonusModalState
            },
            set(value) {
                this.$store.commit('sockets/setDisplayGetBonusModal', value)
            },
        },
        displayWithdrawalSocket: {
            get() {
                return this.displayWithdrawalSocketState
            },
            set(value) {
                this.$store.commit('sockets/setDisplayWithdrawalSocket', value)
            },
        },
    },
    watch: {
        displayRegisterModal(value) {
            this.registerModal = value
        },
        hiddenOverflowLanguageChange(value) {
            // html , body  Language Change Overlay
            if (value) {
                document.documentElement.style.setProperty('overflow', 'hidden')
                document.body.style.setProperty('overflow', 'hidden')
            } else {
                // document.documentElement.style.setProperty('overflow', 'auto')
                // document.body.style.setProperty('overflow', 'auto')
                // remove overflow hidden to prevent issue with some browser
                document.documentElement.style.removeProperty('overflow')
                document.body.style.removeProperty('overflow')
            }
        },
    },
    async mounted() {
        this.$store?.dispatch('app/checkIsApp')
        this.$store.dispatch('player/getPlayerInviteAndEarnDomain')

        this.showBanner()

        this.getFaviconIcon()

        if (this.$route.path !== '/' && !this.isMobileOnly()) {
            this.$store.dispatch('cms/cmsComponentCode', {
                platform: 1,
                component_code: 'DesktopBackground',
            })
        }

        if (this.$route.path !== '/' && this.isMobileOnly()) {
            this.$store.dispatch('cms/cmsComponentCode', {
                platform: 2,
                component_code: 'MobileBackground',
            })
        }

        if (this.$cookie?.get('is_change_language')) {
            this.$store.commit('settings/changeLanguageLoading', true)
        }
        if (this.handleCookie('wl_locale')) {
            this.$recaptcha.language = this.handleCookie('wl_locale')
        }
        this.$store.dispatch('themes/settings/whiteLabel')

        if (this.menubars?.length <= 0)
            this.$store.dispatch('cms/menus/getMenubars')

        if (this.$cookie.get('token')) {
            this.initSocketTheme(globalVar.themes.theme4.value)
            this.socket = await this.$nuxtSocket({
                reconnection: false,
                auth: {
                    Authorization: `Bearer ${this.$cookie.get('token')}`,
                },
                transports: ['websocket'],
            })
            this.socket.on('disconnect', (e) => {
                this.socket.connect()
            })

            // Backend team need this callback
            this.socket.on('ws-ping', (payload, callback) => {
                try {
                    // eslint-disable-next-line n/no-callback-literal
                    callback('ykx52280')
                } catch (_) {}
            })

            let reconnectCount = 0
            this.socket.on('connect_error', (e) => {
                //  in case token is expired
                if (typeof e === 'object') {
                    const message = e?.message
                    try {
                        const messageObject = JSON.parse(message)
                        if (messageObject?.code === 401) {
                            this.logout()
                        }
                    } catch (_) {}
                }
                const MAX_RECONNECTION_FAIL_COUNT = 1000
                const TIME_INTERVAL_TO_RECONNECT = 1000

                if (reconnectCount < MAX_RECONNECTION_FAIL_COUNT) {
                    setTimeout(() => {
                        this.socket.connect()
                    }, TIME_INTERVAL_TO_RECONNECT)
                    reconnectCount++
                }
            })

            this.socket.on('playerBalance', (msg) => {
                this.$store.dispatch('player/totalBalanceSocket', msg)
            })

            // Subscribe Store, Socket Only
            this.$store.subscribeAction((mutation, state) => {
                // Confirm Deposit
                if (
                    mutation.type === 'sockets/revokeWithdrawal' ||
                    mutation.type === 'sockets/successfulWithdrawal' ||
                    mutation.type === 'sockets/revokeDepositByAdmin' ||
                    mutation.type === 'sockets/successfulDeposit'
                ) {
                    if (!this.$root?.isTransactionHistoryPage) return
                    this.$store.dispatch('themes/transaction/getTransactions', {
                        sort: 'created_at|desc',
                        limit: 10,
                        page: 1,
                        language: this.handleCookie('wl_locale'),
                        start_date: '2022-01-01 00:00:00',
                        end_date: this.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    })
                }
            })
        }
        this.onResize()
        this.initializeSettings()
    },
    methods: {
        onResize() {
            if (process.browser) {
                const MOBILE_SCREEN_WIDTH = 1300
                this.isMobileScreen = window.innerWidth < MOBILE_SCREEN_WIDTH
                this.$store.commit(
                    'themes/settings/setIsMobile',
                    this.isMobileScreen
                )
                return null
            }
            this.isMobileScreen = false
            this.$store.commit(
                'themes/settings/setIsMobile',
                this.isMobileScreen
            )
        },
        closeHoldBalanceDialog() {
            this.$store.commit('sockets/setShowHoldBalance', false)
        },
        async initializeSettings() {
            await this.$store.dispatch('settings/supportCountryAndLanguage')
            this.$store.dispatch('cms/floatingIcons')
            if (this.$cookie.get('token')) {
                this.initSocketTheme()
                await this.$store.dispatch(
                    'themes/player-bank/getBankPlayerAccount'
                )
            }
            if (!this.languages?.length) {
                await this.setDefaultLanguages()
            }
            if (this.$cookie.get('currency')) {
                await this.$store.dispatch(
                    'settings/operationSetting',
                    this.$cookie.get('currency')
                )
            }
            if (!this.supportCountries?.length) {
                await this.$store.dispatch('themes/settings/getSupportCountry')
            }
            await this.$store.dispatch('themes/settings/getExchangeRate')
            this.$store.commit('settings/changeLanguageLoading', false)
            this.$cookie.remove('is_change_language')
        },
    },
}
